import { Injectable } from "@angular/core";
import { Permission, ROLE_PERMISSIONS, WILDCARD } from "./_infrastructure/permissions";

@Injectable({ providedIn: 'root' })
export class AppContext {
    constructor() {
    }
    
    public logIn(bearer: string) {
        localStorage.setItem('bearer', bearer);
    }

    public logOut() {
        localStorage.removeItem('bearer');
    }

    get bearer(): string {
        return localStorage.getItem('bearer') as string;
    }

    get loggedIn(): boolean {
        return this.bearer !== '' && this.bearer !== undefined && this.bearer != null;
    }

    get role(): string | null {
        const token = this.bearer;
        if (!token) return null;
        try {
            const payload = token.split('.')[1];
            const decoded = JSON.parse(atob(payload));
            return decoded['Role'] ?? null;
        } catch {
            return null;
        }
    }

    hasPermission(permission: Permission): boolean {
        const role = this.role;
        if (!role) return false;
        const permissions = ROLE_PERMISSIONS[role];
        if (permissions === WILDCARD) return true;
        return permissions?.includes(permission) ?? false;
    }
}